import { AnyUser } from "@megaron/access-control";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { cartActions } from "./cart";
import { dumpActions } from "./dump";
import { googleMerchantsActions } from "./googleMerchants";
import { orderActions } from "./order";
import { shippingRateActions } from "./shippingRates";

export const fulfillmentHttpService = HttpService({
  ...shippingRateActions,
  ...orderActions,
  ...cartActions,
  ...googleMerchantsActions,
  ...dumpActions,
});

export type FulfillmentHandlers = HandlerMap<typeof fulfillmentHttpService, AnyUser>;
